import ContentPreview from './content_preview.ui.jsx';

import fetchTree, { depends, loader, group } from 'fetch-tree';

import { refreshContent, deleteContent } from '../actions/content';
import { contentLoader } from '../resources/content';
import { sectionLoader } from '../resources/section';

import { isInstructorInSection } from '../selectors/current_user';
import { selectCoverImage } from '../selectors/content';
import { cacheCover } from '../actions/offline.js';
import { hideSharingQA } from '../selectors/current_user';
import { setOrigin } from 'actions/content';

export const resources = group({
    content: depends([depends.prop('contentId')], contentLoader),
    section: depends(['content.section_id', 'content'], sectionLoader),
    isInstructor: depends(['section'], isInstructorInSection),
    hideSharingQA,
    coverUrl: depends(
        ['content', 'content.id'],
        loader({
            id: (_, id) => `cover-${id}`,
            action: cacheCover,
            selector: selectCoverImage,
        })
    ),
    linkType: depends(
        ['content.link_cover_override'],
        (state, link_cover_override) => {
            let linkType;
            if (link_cover_override) {
                if (link_cover_override.indexOf('vimeo') >= 0) {
                    linkType = 'vimeo';
                } else if (link_cover_override.indexOf('youtube') >= 0) {
                    linkType = 'youtube';
                } else {
                    linkType = link_cover_override.split(':')[0];
                }
            }
            return linkType;
        }
    ),
});

export default fetchTree({
    component: ContentPreview,
    mapDispatchToProps: {
        refreshContent,
        deleteContent,
        setOrigin,
    },
    resources,
});



// WEBPACK FOOTER //
// ./src/components/content_preview.jsx